import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import AppointmentInfo from "./AppointmentInfo";
import PatientInfo from "./PatientInfo";
import ReasonForVisit from "./ReasonForVisit";
import OpenScheduleConfirmation from "./OpenScheduleConfirmation";
import SelectPatient from '../common/SelectPatient';
import * as d from "../../reducers/domainReducer";
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import OurStepManager from "../common/OurStepManager";
import ConfirmationModal from "../common/ConfirmationModal";
import FeatureDisabled from "../common/FeatureDisabled";
import NoProxy from '../common/NoProxy';
import SelectDoctor from './SelectDoctor';
import AppointmentType from "./AppointmentType";
import StaticHtmlContent from '../common/staticHtmlContent';
import ScheduleBannerMsg from './ScheduleBannerMsg';
import VisitTypeInfo from "./VisitTypeInfo";
import LocationInfo from "./LocationInfo";
import VisitTypeReason from "../appointments/VisitTypeReason";
import PatientStatus from "../appointments/PatientStatus "
import * as msgs from "../../constants/textConstants";
import VerifyAndSchedule from './VerifyAndSchedule';
import * as CryptoJS from 'crypto-js';

const DATE_FORMAT = Tools.getDateFormats();
const DIRECT_SCHEDULE = "DirectSchedule";

class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.refOurStepManager = React.createRef();
        const searchModel = this.getSearchModel();
        let {
            providerId,
            providerIdType,
            scheduleType,
            visitTypeId,    // optional selected visit type id
            departmentId,   // optional selected department id
            selectedDate,   // optional YYYY-MM-DD
            selectedTime,   // optional HH:MM:SS ... dunno why they want the seconds, but they do
            altStart,       // alternative date-range starting date
            correlationId,
            gacookie
        } = searchModel;
        const patient = this.props.currentUser ? this.props.currentUser : undefined;
        const email = this.props.patientEmail ? this.props.patientEmail : "";
        const patientId = "";
        const loginId = "";
        const userName = "";

        if (isNaN(parseInt(visitTypeId))) {
            visitTypeId = "";
        }

        if (isNaN(parseInt(departmentId))) {
            departmentId = "";
        }

        if (!window.serverData.data.enableDirectScheduling) {
            scheduleType = "OpenSchedule";
        }

        if (providerId === DIRECT_SCHEDULE)
            scheduleType = DIRECT_SCHEDULE;

        // default the calendar to either the current month OR to the month selected by the route parameter
        let dt = new Date();
        if (altStart) {
            dt = Tools.toJSDate(`${altStart} 00:00:00`, DATE_FORMAT);
        }
        else if (selectedDate) {
            //const selDt = new Date(`${selectedDate} 00:00:00`);
            dt = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
            //dt = new Date(selDt.getFullYear(), selDt.getMonth(), 1);
        }
        else {
            dt.setDate(1);
        }

        let dtEnd = Tools.getEndOfMonth(dt.getFullYear(), dt.getMonth());
        const isFromVideoVisitOptions = this.props && this.props.location && this.props.location.state && this.props.location.state.isFromVideoVisitOptions;
        const showSpinner = isFromVideoVisitOptions;
        this.scheduleCampaignReferrer = this.props && this.props.location && this.props.location.state && this.props.location.state.scheduleCampaignReferrer;
        this.scheduleCampaignActivity = this.scheduleCampaignReferrer ? { scheduleCampaignReferrer: this.scheduleCampaignReferrer } : {};

        this.state = {
            npi: providerId === DIRECT_SCHEDULE || providerIdType === "EpicID" ? null : providerId,
            epicId: providerIdType === "EpicID" ? providerId : null,
            visitTypeId: visitTypeId,
            departmentId: departmentId,
            newDepartArray: [],
            patientId: patientId,
            loginId: loginId,
            //startDate: altStart ? altStart : `${dt.getFullYear()}-${dt.getMonth() + 1}-1`,
            startDate : correlationId && gacookie ? this.props.match && this.props.match.params.date :altStart ? altStart : `${dt.getFullYear()}-${dt.getMonth() + 1}-1`,
            endDate: `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`,
            visit: {
               // date: selectedDate,
               // time: selectedTime,
                time: correlationId && gacookie ? this.props.match && this.props.match.params.time : selectedTime,
                date: correlationId && gacookie ? this.props.match && this.props.match.params.date : selectedDate,
                duration: 0,
                visitType: {
                    id: visitTypeId,
                    description: "",
                    idType: "",
                    startDate: null,
                    endDate: null
                },
                department: {
                    id: departmentId,
                    name: "",
                    idType: "",
                    phone: "",
                    address: {
                        street1: "",
                        street2: "",
                        city: "",
                        state: "",
                        zip: ""
                    }
                },
                reasonForVisit: "",
                patientStatus: "",
                acceptType:"",
                reasonForVisitValue : "",
                reasonVisitTypeID : "",
                patient: {
                    id: patientId ? patientId : patient ? patient.eid : "",
                    loginId: loginId ? loginId : userName,
                    name: patient ? patient.displayName : "",
                    phoneNumber: "",
                    email: email,
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: ""
                }
            },
            createPatient: {},
            showSpinner: showSpinner,
            initialLoad: true,
            earliestRequested: false,
            scheduleErrorMessage: null,
            scheduleType: this.props && this.props.location && this.props.location.state && this.props.location.state.scheduleType ? this.props.location.state.scheduleType : scheduleType,
            baseURL: "",
            visitTypeChanged: false,
            locationChanged: false,
            startingStep: 0,
            currentStep: 0,
            isFromVideoVisitOptions: isFromVideoVisitOptions,
            noSelectPatient: searchModel.noSelectPatient || (this.props && this.props.location && this.props.location.state && this.props.location.state.noSelectPatient),
            isFromVideoVisitDirectSchedule: "",
            surveyDisplayed: false,
            isFromDotCOM: correlationId && gacookie ? true : false
        };

        this.fromPreventiveCareTile = this.props && this.props.location && this.props.location.state && this.props.location.state.fromPreventiveCareTile;
        this.userSelected = this.props && this.props.location && this.props.location.state && this.props.location.state.selectedUser ? this.props.location.state.selectedUser : null;
        this.loadVisitTypeAndLocation = this.loadVisitTypeAndLocation.bind(this);
        this.loadScheduleForProvider = this.loadScheduleForProvider.bind(this);
        this.saveStepInfo = this.saveStepInfo.bind(this);
        this.resetWizard = this.resetWizard.bind(this);
        this.requestScheduleInfo = this.requestScheduleInfo.bind(this);
        this.setScheduleDates = this.setScheduleDates.bind(this);
        this.scheduleAppointment = this.scheduleAppointment.bind(this);
        this.scheduleServicesAppointment = this.scheduleServicesAppointment.bind(this);
        this.saveSlot = this.saveSlot.bind(this);
        this.createPatient = this.createPatient.bind(this);
        this.checkStartDate = this.checkStartDate.bind(this);
        this.initiateSearch = this.initiateSearch.bind(this);
        this.scrubJsonCharacters = this.scrubJsonCharacters.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.savePatientInfo = this.savePatientInfo.bind(this);
        this.scheduleCallCompleted = this.scheduleCallCompleted.bind(this);
        this.getReasonForVisitComponent = this.getReasonForVisitComponent.bind(this);
        this.render = this.render.bind(this);
        this.getStepManagerComponent = this.getStepManagerComponent.bind(this);
        this.callbackOnLeave = this.callbackOnLeave.bind(this);
        this.getAppointmentType = this.getAppointmentType.bind(this);
        this.getDepartmentAndVisitTypeInfo = this.getDepartmentAndVisitTypeInfo.bind(this);
        this.getVisitInfoCallBack = this.getVisitInfoCallBack.bind(this);
        this.getCurrentStepTitleName = this.getCurrentStepTitleName.bind(this);
        this.gotoEarliestDate = false;
        window.formChanged = false;
        this.apptSlotNotAvailable = false;
        this.apptTimeNotAvailable = false;
    }

    componentWillMount() {
        this.setState({ baseURL: window.location.pathname });
    }

    componentDidMount() {
        if (this.state.npi && this.props && this.props.match && this.props.match.params && this.props.match.params.npi && this.props.match.params.npi !== DIRECT_SCHEDULE)
            this.props.getProviderDetail({ ids: this.state.npi });

        this.initiateSearch();
        if (this.props.match.params.altStart === "") {
            this.setScheduleDates(new Date());
        }
        logUI("MBHWeb.UI.Schedule.ComponentDidMount", new Date(), Tools.getURLPath(), this.scheduleCampaignActivity);
        this.byPassProxy();
    }

    componentDidUpdate(prevProps) {
        const params = location.search ? queryString.parse(location.search) : {};
        if (this.props.serverData.enableNewProviderSchedulingWorkflow && this.state.isFromDotCOM && params && params.reasonType && params.status && params.reasonDesc && prevProps.visitTypeAndLocation !== this.props.visitTypeAndLocation ) {
            const state = this.state;
            const reasonsForVisit = this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.reasonsForVisit;
            if (reasonsForVisit) {
                for (let value of reasonsForVisit) {
                    if (value.visitTypeReason === params.reasonType) {
                        state.visit.accepts = value.accepts ? value.accepts : "";
                    }
                }
            }
            const encryptText = params?.reasonDesc.replace(/\s/g, '+');
            const decryptedDesc = CryptoJS.AES.decrypt(encryptText, window.serverData && window.serverData.data.dotComToWebSecurKey).toString(CryptoJS.enc.Utf8);
            state.visit.reasonForVisitValue =  params.reasonType;
            state.visit.reasonForVisit = decodeURI(decryptedDesc);
            //state.visit.patientStatus = "No, this is the first time";
            state.visit.patientStatus =  params && params.status;
            if (state.visit.patientStatus && state.visit.patientStatus.toLowerCase() === "no, this is the first time") {
               state.visit.acceptType = "New";
            } else {
                state.visit.acceptType = "Existing";
            }
          
            
            this.state.visit.reasonVisitTypeID = this.props.match && this.props.match.params.visitTypeId;
        }

        if (this.state.isFromVideoVisitOptions && this.state.noSelectPatient && this.state.scheduleType === "DirectSchedule" && !this.visitTypeSelected) {
            if (this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.visitTypes) {
                const visitTypes = this.props.visitTypeAndLocation.visitTypes;
                const videoVisitCIDs = this.props.serverData && this.props.serverData.videoVisitCIDs
                    ? this.props.serverData.videoVisitCIDs.split(',') : null;
                if (visitTypes && videoVisitCIDs) {
                    const state = this.state;
                    for (let vCID = 0; vCID < videoVisitCIDs.length; vCID++) {
                        for (let i = 0; i < visitTypes.length; i++) {
                            const vType = visitTypes[i];
                            for (let j = 0; j < vType.iDs.length; j++) {
                                const id = vType.iDs[j];
                                if (videoVisitCIDs[vCID] === id.id) {
                                    state.visit.visitType.id = id.id;
                                    state.visit.visitType.idType = id.type;
                                    state.visit.visitType.description = vType.displayName;
                                    state.visitTypeId = id.id;
                                    this.visitTypeSelected = true;
                                    break;
                                }
                            }
                            if (this.visitTypeSelected) {
                                this.setState({ isFromVideoVisitDirectSchedule: `${state.visit.visitType.id}|${state.visit.visitType.idType}` });
                                //this.saveStepInfo({ visit: state.visit, visitTypeChanged: true }, state.visit.visitType.id !== "" && state.visit.department.id !== "", true); //this is called as it is already calling schedule api for selected visitype.
                                break;
                            }
                        }
                        if (this.visitTypeSelected) {
                            break;
                        }
                    }
                }
            }
        }
      
        if (document.getElementsByClassName("status-banner-container status-success").length > 0 && !this.state.surveyDisplayed) {
            console.info(`Schedule componentDidUpdate loading survey`);
            try {
                if (window.QSI && window.QSI.API) {
                    window.QSI.API.unload();
                    window.QSI.API.load().done(() => {
                        console.info(`Schedule componentDidUpdate QSI.API.run() SUCCESS ${document.getElementsByClassName("status-banner-container status-success").length}`);
                        window.QSI.API.run();
                    });
                    this.setState({ surveyDisplayed: true });
                }
            } catch (e) {
                console.warn(`Schedule componentDidUpdate QSI.API.run() failed`, e);
            }
        }
    }

    componentWillUnmount() {
        this.props.clearReduxState();
    }

    componentDidCatch(err, info) {
        console.error(err, info);
        let json = { error: err, componentStack: info };
        //logUI("MBHWeb.UI.Schedule.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(),
            JSON.stringify(err), JSON.stringify(info)
        );
        throw err; // if we're not going to be a property Error boundary, throw it  :)
    }

    byPassProxy = () => {
        const {location, updateBypassProxyAndInfo} = this.props;
        const params = location.search ? queryString.parse(location.search) : {};
        const {bypassProxyAndInfo = false} = params;
        if (bypassProxyAndInfo && bypassProxyAndInfo !== 'false') {
            updateBypassProxyAndInfo(true);
        }
    }

    getSearchModel() {
        const { match, location } = this.props;
        let searchModel = match && match.params;
        if (searchModel.npi && searchModel.npi !== 'null') {
            searchModel.providerIdType = 'NPI';
            searchModel.providerId = searchModel.npi;
        }
        else {
            searchModel = location.search ? queryString.parse(location.search) : location.searchParms && queryString.parse(location.searchParms);
            if (!searchModel) {
                return {};
            }
            searchModel.providerIdType = 'EpicID';
            searchModel.providerId = searchModel.epicId;
        }
        if (!searchModel.scheduleType) {
            searchModel.scheduleType = 'OpenSchedule';
        }
        searchModel.selectedDate = searchModel.date;
        searchModel.selectedTime = searchModel.time;
        return searchModel;
    }

    blockNavigation = (nextLocation) => {
        const re = /^\/schedule|\/scheduling|\/findcare/;  // We dont need ConfirmationModal when it is triggered either by Steps/flushot/mammography/findcare routes.
        return nextLocation !== null && re.test(nextLocation.pathname);
    }

    getUpdatedState(scheduleDays) {
        const state = this.state;

        if (!state.visit.date && scheduleDays && scheduleDays.length) {
            state.visit.date = scheduleDays[0].date;
        }

        if (this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.departments) {
            const departments = this.props.visitTypeAndLocation.departments;
            for (let i = 0; i < departments.length; i++) {
                const dept = departments[i];
                for (let j = 0; j < dept.iDs.length; j++) {
                    const id = dept.iDs[j];
                    if (id.id === this.state.visit.department.id) {
                        state.visit.department.idType = id.type;
                        state.visit.department.address.street1 = dept.address1;
                        state.visit.department.address.street2 = dept.address2;
                        state.visit.department.address.city = dept.city;
                        state.visit.department.address.state = dept.state;
                        state.visit.department.address.zip = dept.zip;
                        state.visit.department.phone = dept.phone;
                    }
                }
            }
        }

        if (state.visit.visitType.id !== "" && state.visit.visitType.idType === "") {
            if (this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.visitTypes) {
                const visitTypes = this.props.visitTypeAndLocation.visitTypes;
                if (visitTypes) {
                    for (let i = 0; i < visitTypes.length; i++) {
                        const v = visitTypes[i];
                        for (let j = 0; j < v.iDs.length; j++) {
                            const id = v.iDs[j];
                            if (id.id === this.state.visit.visitType.id) {
                                state.visit.visitType.idType = id.type;
                                state.visit.visitType.description = v.displayName;
                            }
                        }
                    }
                }
            }
        }

        return state;
    }

    onOpenScheculingCallCompleted = (scheduleDays) => {
        this.waitingOnScheduleCall = false;

        if (this.gotoEarliestDate && this.earliestScheduleApplied) {
            return;
        }

        const state = this.getUpdatedState(scheduleDays);

        if (!this.waitingOnEarliestScheduleCall && !this.waitingOnScheduleCall2) {

            state.showSpinner = false;
        }

        this.setState(state);
    }

    callBasedOffEarliestScheduleCompleted = (scheduleDays) => {
        if (!this.gotoEarliestDate) {
            return;
        }

        const state = this.getUpdatedState(scheduleDays);

        if (!this.waitingOnEarliestScheduleCall) {
            state.showSpinner = false;
        }

        this.setState(state, () => {
            this.earliestScheduleApplied = true;
            this.waitingOnScheduleCall2 = false;
        });
    }

    onEarliestScheduleCallCompleted = () => {
        if (this.props.earliestSchedule) {
            const state = this.state;

            if (this.props.earliestSchedule.scheduleDays && this.props.earliestSchedule.scheduleDays.length > 0) {
                let earliestDt = Tools.toJSDate(`${this.props.earliestSchedule.scheduleDays[0].date} 00:00:00`, DATE_FORMAT);
                let selectedDate = Tools.toJSDate(`${state.visit.date} 00:00:00`, DATE_FORMAT);
                let endDt = Tools.toJSDate(`${earliestDt.getFullYear()}-${earliestDt.getMonth() + 1}-${earliestDt.getDate()} 00:00:00`, DATE_FORMAT);
                endDt.setDate(1);
                endDt.setDate(endDt.getDate() + 30);

                const npi = state.npi || this.npi;
                if (selectedDate.getDate() !== earliestDt.getDate()) {
                    state.startDate = `${earliestDt.getFullYear()}-${earliestDt.getMonth() + 1}-${earliestDt.getDate()}`;
                    state.endDate = `${endDt.getFullYear()}-${endDt.getMonth() + 1}-${endDt.getDate()}`;
                    if (this.gotoEarliestDate) {
                        state.visit.date = `${earliestDt.getFullYear()}-${earliestDt.getMonth() + 1}-${earliestDt.getDate()}`;
                        const searchModel = {
                            providerId: npi ? npi : state.epicId || this.epicId,
                            providerIdType: npi  ? "NPI" : "EpicID",
                            departmentId: state.visit.department.id,
                            scheduleType: state.scheduleType,
                            visitTypeId: state.visit.reasonVisitTypeID ? state.visit.reasonVisitTypeID :state.visit.visitType.id,
                            start: state.visit.date,
                            end: state.endDate,
                            getEarliestSchedule: false
                        };

                        if (this.state.scheduleType === "DirectSchedule") {
                            searchModel.loginId = this.props.patientLoginId;
                            searchModel.patientId = this.props.externalID;
                            searchModel.patientIdType = "External";
                            searchModel.authorization = this.props.userToken;
                        }

                        this.waitingOnScheduleCall2 = true;
                        this.props.getScheduleInfo(searchModel, this.callBasedOffEarliestScheduleCompleted);
                    }
                }  // check current month against this.props.earliestSchedule; if it's less, adjust it to match earliest...ONLY on the initial load.
                else if (selectedDate.getTime() < earliestDt.getTime()) {
                    state.visit.date = `${earliestDt.getFullYear()}-${earliestDt.getMonth() + 1}-${earliestDt.getDate()}`;
                    state.startDate = `${earliestDt.getFullYear()}-${earliestDt.getMonth() + 1}-${earliestDt.getDate()}`;
                    state.endDate = `${endDt.getFullYear()}-${endDt.getMonth() + 1}-${endDt.getDate()}`;
                }
            }

            this.waitingOnEarliestScheduleCall = false;
            if (!this.waitingOnScheduleCall && !this.waitingOnScheduleCall2) {
                state.showSpinner = false;
            }

            this.setState(state);
        }
    }

    initiateSearch() {
        const searchModel = this.getSearchModel();
        let {
            providerId,     // required
            providerIdType, // required
            selectedDate,   // optional YYYY-MM-DD
        } = searchModel;

        let dt = new Date();
        if (selectedDate !== "") {
            const selDt = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
            dt = new Date(selDt.getFullYear(), selDt.getMonth(), 1);
        }
        else {
            dt.setDate(1);
        }

        if (providerId && providerId !== DIRECT_SCHEDULE) {
            this.loadVisitTypeAndLocation(providerId, providerIdType);
        }

        // wizard screen 0's visit type and department have been provided by route params; load the calendar...
        const isYourDoctorScheduleType = this.props.location && this.props.location.state && this.props.location.state.scheduleType;
        const { npi, epicId, visit, isFromVideoVisitOptions, isFromDotCOM} = this.state;
        if (((npi && npi !== "") || (epicId && epicId !== "")) && visit.visitType.id !== "" && visit.department.id !== "") {
            if (!isYourDoctorScheduleType) {//skip if the redirecting from yourdoctor on videovisits as this call might not be required at this moment.
                if (isFromVideoVisitOptions || isFromDotCOM) { //From mamo or video visit or .COM workflow call schedule days to show, else user need to pick depart and visit type to call. 
                    this.setState({ showSpinner: true });
                    if (this.props.searchRunning === false) {
                        this.loadScheduleForProvider();
                    }
                    logUI("MBHWeb.Schedule.Open.LoadProviderSchedule", new Date(), Tools.getURLPath(), searchModel);
                }
            }
        }
    }

    // edge case: provider has no availability in the month being displayed. Move the calendar to the correct month.
    checkStartDate(dtFirstAvailable) {

        let dtStart = Tools.toJSDate(`${this.state.startDate} 00:00:00`, DATE_FORMAT);
        let dtEnd = Tools.toJSDate(`${this.state.endDate} 00:00:00`, DATE_FORMAT);

        if (dtStart.getMonth() < dtFirstAvailable.getMonth()) {
            dtStart = Tools.toJSDate(`${dtFirstAvailable.getFullYear()}-${dtFirstAvailable.getMonth() + 1}-1 00:00:00`, DATE_FORMAT);
            dtEnd = this.getEndDate(dtStart);

            let visit = this.state.visit;
            visit.date = `${dtFirstAvailable.getFullYear()}-${dtFirstAvailable.getMonth() + 1}-${dtFirstAvailable.getDate()} 00:00:00`;
            visit.time = "";

            this.setState({
                startDate: `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`,
                endDate: `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`,
                visit: visit
            });
        }

    }

    setScheduleDates(startDt) {
        let dtStart = new Date(startDt);
        dtStart.setDate(1);
        let dtEnd = this.getEndDate(dtStart);

        this.setState({
            startDate: `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`,
            endDate: `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`
        });
    }

    loadPatientStatus = (visit) => {
        this.setState({
            visit : visit
        })
        this.initiateSearch();
    }

    loadVisitTypeAndLocation(providerId, providerIdType, scheduleType) {
        if (!providerIdType) {
            providerIdType = 'NPI';
        }
        const searchModel = { 
            providerId, 
            providerIdType, 
            scheduleType: scheduleType ? scheduleType : this.state.scheduleType,
            accepts: this.props.serverData.enableNewProviderSchedulingWorkflow && this.state.visit.acceptType ?  this.state.visit.acceptType : "Both",
         };

        if (scheduleType === "DirectSchedule" || this.state.scheduleType === "DirectSchedule") {
            searchModel.loginId = this.props.patientLoginId;
            searchModel.patientId = this.props.externalID;
            searchModel.patientIdType = "External";
            searchModel.authorization = this.props.userToken;
        }

        if (providerIdType === "NPI") {
            this.npi = providerId;
        }

        if (providerId && (!this.state.npi))
            this.setState({ dontLoadSchedule: true });
        else
            this.setState({ dontLoadSchedule: false });

        logUI("MBHWeb.Schedule.Open.LoadVisitTypeAndLocation", new Date(), Tools.getURLPath(), searchModel);
        this.props.getVisitInfo(searchModel, this.props.serverData && this.props.serverData.enableNewProviderSchedulingWorkflow,  this.getVisitInfoCallBack );
    }

    getVisitInfoCallBack(isSuccess, visitInfo) {
        const enableNewProviderSchedulingWorkflow = this.props.serverData && this.props.serverData.enableNewProviderSchedulingWorkflow;

        if (isSuccess) {
            const state = this.state;
            let isNeedVisitUpdate = false;
            let isNeedDepartmentUpdate = false;
            const { serverData } = this.props;
            if (state.visit.visitType && state.visit.visitType.id !== "") {
                if (visitInfo && visitInfo.visitTypes) {
                    const visitTypes = visitInfo.visitTypes;
                    if (visitTypes) {
                        for (let i = 0; i < visitTypes.length; i++) {
                            const v = visitTypes[i];
                            for (let j = 0; j < v.iDs.length; j++) {
                                const id = v.iDs[j];
                                if (id.id === state.visit.visitType && state.visit.visitType.id) {
                                    state.visit.visitType.idType = id.type;
                                    state.visit.visitType.description = v.displayName;
                                    if (serverData && serverData.enableV3SearchForAllProviders && !(this.state.isFromDotCOM && enableNewProviderSchedulingWorkflow)) {
                                        state.visit.visitType.startDate = v.earliestCachedSlotDate;
                                    }
                                    isNeedVisitUpdate = true;
                                    break;
                                }
                            }
                            if (isNeedVisitUpdate) {
                                break;
                            }
                        }
                    }
                }
            }

            if (state.visit.department.id !== "" && state.visit.department.idType === '') {
                const departments = visitInfo && visitInfo.departments ? visitInfo.departments : [];
                for (let i = 0; i < departments.length; i++) {
                    const dept = departments[i];
                    for (let j = 0; j < dept.iDs.length; j++) {
                        const id = dept.iDs[j];
                        if (id.id === state.visit.department.id) {
                            state.visit.department.idType = id.type;
                            state.visit.department.address.street1 = dept.address1;
                            state.visit.department.address.street2 = dept.address2;
                            state.visit.department.address.city = dept.city;
                            state.visit.department.address.state = dept.state;
                            state.visit.department.address.zip = dept.zip;
                            state.visit.department.phone = dept.phone;
                            isNeedDepartmentUpdate = true;
                            break;
                        }
                    }
                    if (isNeedDepartmentUpdate) {
                        break;
                    }
                }
            }

            if (isNeedVisitUpdate || isNeedDepartmentUpdate) {
                this.setState(state);
            }

            //if workflow started from .com, then skip the visit and location info step.
            if (state.isFromDotCOM) {
                const patientInfoStepValue = this.getIndexByStepTitle("Patient Info");
                const reasonSubmitStepValue = this.getIndexByStepTitle("Verify & Schedule");
                const enableNewProviderSchedulingWorkflow = this.props.serverData && this.props.serverData.enableNewProviderSchedulingWorkflow;
                //const enableCustomDirectScheduling = this.props.serverData && this.props.serverData.enableCustomDirectScheduling && this.state.scheduleType === "DirectSchedule";
                const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info");
                const selectPatientStepValue = this.getIndexByStepTitle("Select Patient");
                if (!state.isFromVideoVisitOptions && this.refOurStepManager && this.refOurStepManager.current
                    && this.refOurStepManager.current.wrappedInstance && apptInfoStepValue !== -1 && selectPatientStepValue === -1) {
                    if (enableNewProviderSchedulingWorkflow && !this.apptSlotNotAvailable && !this.props.getScheduleError && !this.apptTimeNotAvailable && !this.props.hasMyChart) {
                        this.refOurStepManager.current.wrappedInstance.goToNewStep(true, patientInfoStepValue);
                    } 
                    else if (enableNewProviderSchedulingWorkflow && !this.apptSlotNotAvailable && !this.props.getScheduleError && !this.apptTimeNotAvailable && this.props.hasMyChart) {
                        this.refOurStepManager.current.wrappedInstance.goToNewStep(true, reasonSubmitStepValue);
                    }
                    else {
                        this.refOurStepManager.current.wrappedInstance.goToNewStep(true, apptInfoStepValue);
                    }
                }
            }
        }

    }

    loadScheduleForProvider() {
        const isFromDotCOM = this.state.isFromDotCOM ? this.state.isFromDotCOM : "" ;

        let startDate = this.state.startDate ? Tools.toJSDate(this.state.startDate) : "" ;
        let startDt = isFromDotCOM && startDate ? Tools.getStartOfMonth(startDate.getFullYear(), startDate.getMonth()) : startDate && startDate ;  
        let dt = startDt && Tools.toJSDate(startDt)
        let start = dt && Tools.dateSimpleFormat(dt);
        let end = this.state.endDate;

        // bugfix
        if (this.state.startDate.indexOf("NaN") >= 0) {
            let dtStart = new Date();
            dt.setDate(1);

            let dtEnd = new Date();
            dtEnd.setDate(1);
            dtEnd.setDate(dt.getDate() + 29);

            start = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
            end = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;
        }

        if (this.state.scheduleType === "DirectSchedule") {
            // direct does not allow a start date that preceeds the current date.
            const today = new Date();
            const startDay = new Date(start);
            if (startDay.getTime() < today.getTime()) {
                start = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
            }
        }

        let searchModel = null;
        const npi = this.state.npi;
        searchModel = {
            providerId: npi ? npi : this.state.epicId,
            providerIdType: npi  ? "NPI" : "EpicID",
            departmentId: this.state.visit.department.id,
            scheduleType: this.state.scheduleType,
            //visitTypeId: this.state.visit.visitType.id,
            visitTypeId : this.state.visit.reasonVisitTypeID ? this.state.visit.reasonVisitTypeID :this.state.visit.visitType.id,

            start: start,
            end: end,
            getEarliestSchedule: false
        };

        if (this.state.scheduleType === "DirectSchedule") {
            searchModel.loginId = this.props.patientLoginId;
            searchModel.patientId = this.props.externalID;
            searchModel.patientIdType = "External";
            searchModel.authorization = this.props.userToken;
        }
        this.setState({ showSpinner: true });
        this.waitingOnScheduleCall = true;
        this.waitingOnEarliestScheduleCall = false;
        this.earliestScheduleApplied = false;
        this.props.getScheduleInfo(searchModel, this.onOpenScheculingCallCompleted, this.onEarliestScheduleCallCompleted);
    }

    resetWizard() {
        //debugger;
        if (typeof window !== 'undefined') {
            window.sessionStorage.setItem('openScheduleStep', 0);
        }

        const npi = this.props.match.params.npi;                                                                    // required
        const epicId = this.getEpicId();
        const visitTypeId = this.props.match.params.visitTypeId ? this.props.match.params.visitTypeId : "";         // optional selected visit type id
        const departmentId = this.props.match.params.departmentId ? this.props.match.params.departmentId : "";      // optional selected department id
        let selectedDate = this.props.match.params.date ? this.props.match.params.date : "";                        // optional YYYY-MM-DD
        const selectedTime = this.props.match.params.time ? this.props.match.params.time : "";                      // optional HH:MM:SS ... dunno why they want the seconds, but they do

        const altStart = this.props.match.params.altStart ? this.props.match.params.altStart : "";                  // alternative date-range starting date
        const altEnd = this.props.match.params.altEnd ? this.props.match.params.altEnd : "";                        // alternative date-range ending date

        const patient = this.props.currentUser ? this.props.currentUser : undefined;
        const email = this.props.patientEmail ? this.props.patientEmail : "";
        const patientId = "";
        const loginId = "";
        const userName = "";
        let dt = new Date();

        // if (selectedDate !== "") {
        //     const selDt = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
        //     //dt = new Date(selDt.getFullYear(), selDt.getMonth(), 1);
        // }

        dt.setDate(1);

        //let dtEnd = new Date(dt);
        //dtEnd.setDate(dt.getDate() + 30);
        let dtEnd = this.getEndDate(dt);

        this.getEndDate(dt);

        let scheduleType = this.props.match.params.scheduleType ? this.props.match.params.scheduleType : "OpenSchedule";

        if (!window.serverData.data.enableDirectScheduling) {
            scheduleType = "OpenSchedule";
        }

        this.setState({
            npi: npi,
            epicId: epicId,
            visitTypeId: visitTypeId,
            departmentId: departmentId,
            patientId: patientId,
            loginId: loginId,
            startDate: altStart !== "" ? altStart : `${dt.getFullYear()}-${dt.getMonth() + 1}-1`,
            endDate: altEnd !== "" ? altEnd : `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`,
            visit: {
                date: selectedDate,
                time: selectedTime,
                duration: 0,
                visitType: {
                    id: visitTypeId,
                    description: "",
                    idType: "",
                    startDate: null
                },
                department: {
                    id: departmentId,
                    name: "",
                    idType: "",
                    phone: "",
                    address: {
                        street1: "",
                        street2: "",
                        city: "",
                        state: "",
                        zip: ""
                    }
                },
                reasonForVisit: "",
                patient: {
                    id: patientId ? patientId : patient ? patient.eid : "",
                    loginId: loginId ? loginId : userName,
                    name: patient ? patient.displayName : "",
                    phoneNumber: "",
                    email: email,
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: ""
                }
            },
            showSpinner: false,
            createPatientInfo: null,
            scheduleType: scheduleType
        });

    }

    saveStepInfo(info, loadSchedule, gotoEarliestDate, allowStepForward) {
        this.gotoEarliestDate = gotoEarliestDate;
        window.formChanged = true;
        this.setState({ ...info }, () => {
            const { dontLoadSchedule } = this.state;
            // request schedule info for the calendar once we've got the ids...
            //if (this.state.visit.visitType.id !== "" && this.state.visit.department.id !== "" /*&& this.state.visit.date === "" && this.state.visit.time === "" */ && this.state.visit.reasonForVisit === "" && this.props.getSchedulePending === false) {
            if (loadSchedule === true && !dontLoadSchedule) {
                //logUI("MBHWeb.Schedule.Open.RequestScheduleInfo", new Date(), Tools.getURLPath(), info);
                logUI("MBHWeb.Schedule.Open.RequestScheduleInfo", new Date(), Tools.getURLPath(), { ...info, scheduleCampaignActivity: this.scheduleCampaignActivity  });
                this.requestScheduleInfo(allowStepForward, gotoEarliestDate);
                
            }
           
            // post schedule once we've got the ids and the reason...
            if (this.state.visit.visitType.id !== "" && this.state.visit.department.id !== "" && this.state.visit.date !== "" && this.state.visit.time !== "" && this.state.visit.reasonForVisit !== "") {
                //logUI("MBHWeb.Schedule.Appointment", new Date(), Tools.getURLPath(), info);
                logUI("MBHWeb.Schedule.Appointment", new Date(), Tools.getURLPath(), { ...info, scheduleCampaignActivity: this.scheduleCampaignActivity });
                //this.scheduleAppointment();
            }
        });
    }

    saveSlot(time, duration) {
        let visit = this.state.visit;
        visit.time = time;
        visit.duration = duration;
        this.saveStepInfo({ visit: visit });
    }

    getStepManagerComponent() {
        return Tools.getRootRef(this.refOurStepManager.current);
    }

    getReasonForVisitComponent() {
        const oStepManager = this.getStepManagerComponent();
        let oRet = null;
        oStepManager.referenceCollection.map((thisStep, index) => {
            if (thisStep.current instanceof ReasonForVisit) {
                oRet = thisStep;
            }
        });
        return oRet;
    }

    //Handle unexpected issue regarding visit type.
    getDepartmentAndVisitTypeInfo(departmentId, visitTypeId) {
        let departmentIdType = null;
        let visitIdType = null;
        if (departmentId && this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.departments) {
            const departments = this.props.visitTypeAndLocation.departments;
            for (let i = 0; i < departments.length; i++) {
                const dept = departments[i];
                for (let j = 0; j < dept.iDs.length; j++) {
                    const id = dept.iDs[j];
                    if (id.id === departmentId) {
                        departmentIdType = id.type;
                        break;
                    }
                }
            }
        }
        if (visitTypeId && this.props.visitTypeAndLocation && this.props.visitTypeAndLocation.visitTypes) {
            const visitTypes = this.props.visitTypeAndLocation.visitTypes;
            for (let i = 0; i < visitTypes.length; i++) {
                const v = visitTypes[i];
                for (let j = 0; j < v.iDs.length; j++) {
                    const id = v.iDs[j];
                    if (id.id === visitTypeId) {
                        visitIdType = id.type;
                        break;
                    }
                }
            }
        }

        if (departmentIdType && visitIdType) {
            logUI("MBHWeb.UI.Schedule.SetDepartmentAndVisitTypeInfo.Success", new Date(), Tools.getURLPath());
        } else {
            logUI("MBHWeb.UI.Schedule.SetDepartmentAndVisitTypeInfo.Failure", new Date(), Tools.getURLPath(), {
                departmentId: departmentId ? departmentId : null,
                visitTypeId: visitTypeId ? visitTypeId: null,
                visitTypeAndLocation: this.props.visitTypeAndLocation ? this.props.visitTypeAndLocation : null
            });
        }

        return { departmentIdType, visitIdType };
    }

    scheduleAppointment() {
        const token = this.props.userToken;
        const { createPatient } = this.state;
        let visit = this.state.visit;

        //Handle visittype reset issue.(Bug:87197)
        if (visit && (!visit.visitType.idType || !visit.department.idType)) {
            logUI("MBHWeb.UI.Schedule.DepartmentAndVisitTypeInfo.NotFound", new Date(), Tools.getURLPath(), visit);
            const apptTypeInfo = this.getDepartmentAndVisitTypeInfo(visit.department.id, visit.visitType.id);
            visit.department.idType = apptTypeInfo.departmentIdType;
            visit.visitType.idType = apptTypeInfo.visitIdType;
        }
        let dt = visit.date;

        //debugger;

        // kid you not, the api will throw errors if the date isn't padded with zeros.
        let parts = dt.split("-");
        parts[1] = parts[1].padStart(2, '0');
        parts[2] = parts[2].padStart(2, '0');
        dt = parts.join("-");

        let id = this.props.currentUser ? this.props.currentUser.externalId : "";
        let idType = "External";
        let patientModel = {};

        if (createPatient && Object.keys(createPatient).length > 0) {
            patientModel = {
                firstName: this.props.userDetails.Givenname,
                lastName: this.props.userDetails.Surname,
                email: createPatient.email ? createPatient.email : this.props.userDetails.Email,
                dateOfBirth: createPatient.dateOfBirth ? createPatient.dateOfBirth : "",
                gender: createPatient.gender ? createPatient.gender : "",
                nationalIdentifier: createPatient.nationalIdentifier ? createPatient.nationalIdentifier : "",
                departmentId: visit.department.id,
                departmentIdType: visit.department.idType
            };

            if (createPatient.phoneNumbers && createPatient.phoneNumbers.length > 0) {
                patientModel.phoneNumbers = this.state.createPatient.phoneNumbers;
            }

            if (createPatient.houseNumber) {
                patientModel.houseNumber = createPatient.houseNumber;
                patientModel.streetLine1 = createPatient.streetLine1;
                patientModel.city = createPatient.city;
                patientModel.state = createPatient.state;
                patientModel.zipCode = createPatient.zipCode;
            }
        }

        let scheduleModel = null;
        const npi = this.state.npi || this.npi;
        scheduleModel = {
            scheduleType: this.state.scheduleType,
            loginId: this.props.patientLoginId,
            myChartId: "",
            proxyPatientId: id,
            proxyPatientIdType: idType,
            visitTypeId: this.state.visit.reasonVisitTypeID ? this.state.visit.reasonVisitTypeID : this.state.visit.visitType.id,
            visitTypeIdType: visit.visitType.idType,
            providerId: npi ? npi : this.state.epicId || epicId,
            providerIdType: npi ? "ProviderNPI" : "PROVID",
            departmentId: visit.department.id,
            departmentIdType: visit.department.idType,
            date: dt,
            time: visit.time,
            comments: this.scrubJsonCharacters(visit.reasonForVisit),
            ...this.scheduleCampaignActivity
        };

        // insurance is only supplied when creating a patient...it won't exist otherwise.
        const insurance = createPatient.insurance;
        if (insurance && insurance.insuranceName !== "") {
            scheduleModel.insurance = {
                insuranceName: insurance.insuranceName,
                memberNumber: insurance.memberNumber,
                groupNumber: insurance.groupNumber,
                subscriberId: insurance.subscriberId
            };
        }

        if (this.state.scheduleType === "DirectSchedule") {
            scheduleModel.duration = visit.duration;
            scheduleModel.patientId = this.props.externalID;
            scheduleModel.patientIdType = "External";
            scheduleModel.authorization = this.props.userToken;
        }

        if (this.props.currentUser && this.props.hasMyChart) {
            logUI("MBHWeb.UI.Schedule.ScheduleAppointment", new Date(), Tools.getURLPath(), scheduleModel);            
            // schedule appointment for existing patient...
            this.props.scheduleAppointment(scheduleModel, token, this.scheduleCallCompleted);
        }
        else {
            //logUI("MBHWeb.UI.Schedule.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath());
            logUI("MBHWeb.UI.Schedule.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath(), this.scheduleCampaignActivity);
            // create patient and schedule appointment...
            this.props.createAndSchedule(patientModel, scheduleModel, token, this.scheduleCallCompleted);
        }

        //Load step at top of page
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        this.updateAddDependentShowPreference();
    }

    scheduleServicesAppointment() {
        const token = this.props.userToken;
        const { createPatient } = this.state;
        let visit = this.state.visit;
        let dt = visit.date;
        let parts = dt.split("-");
        parts[1] = parts[1].padStart(2, '0');
        parts[2] = parts[2].padStart(2, '0');
        dt = parts.join("-");

        let id = this.props.currentUser ? this.props.currentUser.externalId : "";
        let idType = "External";
        let patientModel = {};

        if (createPatient && Object.keys(createPatient).length > 0) {
            patientModel = {
                firstName: this.props.userDetails.Givenname,
                lastName: this.props.userDetails.Surname,
                email: createPatient.email ? createPatient.email : this.props.userDetails.Email,
                dateOfBirth: createPatient.dateOfBirth ? createPatient.dateOfBirth : "",
                gender: createPatient.gender ? createPatient.gender : "",
                nationalIdentifier: createPatient.nationalIdentifier ? createPatient.nationalIdentifier : "",
                departmentId: visit.department.id,
                departmentIdType: visit.department.idType
            };

            if (createPatient.phoneNumbers && createPatient.phoneNumbers.length > 0) {
                patientModel.phoneNumbers = this.state.createPatient.phoneNumbers;
            }

            if (createPatient.houseNumber) {
                patientModel.houseNumber = createPatient.houseNumber;
                patientModel.streetLine1 = createPatient.streetLine1;
                patientModel.city = createPatient.city;
                patientModel.state = createPatient.state;
                patientModel.zipCode = createPatient.zipCode;
            }
        }

        let scheduleModel = null;
        const npi = this.state.npi || this.npi;
        scheduleModel = {
            scheduleType: this.state.scheduleType,
            loginId: this.props.patientLoginId,
            myChartId: "",
            proxyPatientId: id,
            proxyPatientIdType: idType,
            visitTypeId: `${visit.visitType.id}`,
            visitTypeIdType: visit.visitType.idType,
            providerId: npi ? npi : this.state.epicId || epicId,
            providerIdType: this.state.scheduleType != "OpenSchedule" ? "ProviderNPI" : "PROVID",
            departmentId: `${visit.department.id}`,
            departmentIdType: visit.department.idType,
            date: dt,
            time: visit.time,
            ...this.scheduleCampaignActivity
        };

        const insurance = createPatient.insurance;
        if (insurance && insurance.insuranceName !== "") {
            scheduleModel.insurance = {
                insuranceName: insurance.insuranceName,
                memberNumber: insurance.memberNumber,
                groupNumber: insurance.groupNumber,
                subscriberId: insurance.subscriberId
            };
        }

        if (this.state.scheduleType === "DirectSchedule") {
            scheduleModel.duration = visit.duration;
            scheduleModel.patientId = this.props.externalID;
            scheduleModel.patientIdType = "External";
            scheduleModel.authorization = this.props.userToken;
        }

        if (this.props.currentUser && this.props.hasMyChart) {
            logUI("MBHWeb.UI.Schedule.ScheduleAppointment", new Date(), Tools.getURLPath(), scheduleModel);            
            // schedule appointment for existing patient...
            this.props.scheduleAppointment(scheduleModel, token, this.scheduleCallCompleted);
        }
        else {
            //logUI("MBHWeb.UI.Schedule.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath());
            logUI("MBHWeb.UI.Schedule.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath(), this.scheduleCampaignActivity);
            // create patient and schedule appointment...
            this.props.createAndSchedule(patientModel, scheduleModel, token, this.scheduleCallCompleted);
        }

        //Load step at top of page
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        this.updateAddDependentShowPreference();
    }

    scheduleCallCompleted(bSuccessful, sErrorMessage) {
        let { scheduleErrorMessage } = this.state;
        if (bSuccessful) {
            if (scheduleErrorMessage !== "") {
                scheduleErrorMessage = "";
            }
        }
        else {
            if (scheduleErrorMessage !== sErrorMessage) {
                scheduleErrorMessage = sErrorMessage;
            }
        }
        this.setState({ scheduleCompleted: true, scheduleErrorMessage });
    }

    scrubJsonCharacters(string) {
        return string.replace(/[\{\}\[\]]/gim, "");
    }

    requestScheduleInfo(allowStepForward, getEarliestSchedule) {
        const { visit } = this.state;
        const { serverData } = this.props;
        const enableNewProviderSchedulingWorkflow = serverData && serverData.enableNewProviderSchedulingWorkflow;

        const enableV3SearchForAllProviders = serverData && serverData.enableV3SearchForAllProviders;
        if (!enableV3SearchForAllProviders || (enableNewProviderSchedulingWorkflow && this.state.isFromDotCOM)) {
            visit.visitType.startDate = '';
            visit.visitType.endDate = '';
        }
        let start1 = Tools.toJSDate(`${visit && visit.visitType && visit.visitType.startDate ? visit.visitType.startDate : this.state.startDate} 00:00:00`, DATE_FORMAT);
        let startDt1 = `${this.state.startDate} 00:00:00`;
        if (this.state.scheduleType === "DirectSchedule") {
            const today = new Date();
            if (start1.getTime() < today.getTime()) {
                startDt1 = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
            }
        }
        else {
            startDt1 = `${start1.getFullYear()}-${start1.getMonth() + 1}-${start1.getDate()}`;
        }

        let m = null;
        m = null;
        m = null;
        m = new Object();
        m.start = startDt1;
        m.end = visit && visit.visitType && visit.visitType.endDate ? visit.visitType.endDate : this.state.endDate;
        const npi = this.state.npi || this.npi;
        if (npi) {
            m.providerId = npi;
            m.providerIdType = "NPI";
        }
        else {
            m.providerId = this.state.epicId || this.epicId;
            m.providerIdType = "EpicID";
        }
      
        m.scheduleType = this.state.scheduleType;
        //m.visitTypeId = this.state.visit.visitType.id;
        m.visitTypeId = this.state.visit.reasonVisitTypeID ? this.state.visit.reasonVisitTypeID :this.state.visit.visitType.id,
        m.departmentId = this.state.visit.department.id;
        m.allowStepForward = allowStepForward === undefined ? false : allowStepForward;
        m.getEarliestSchedule = getEarliestSchedule === undefined ? false : getEarliestSchedule;

        if (this.state.scheduleType === "DirectSchedule") {
            m.loginId = this.props.patientLoginId;
            m.patientId = this.props.externalID;
            m.patientIdType = "External";
            m.authorization = this.props.userToken;
        }

        this.waitingOnScheduleCall = true;
        this.waitingOnEarliestScheduleCall = getEarliestSchedule;
        this.earliestScheduleApplied = false;
        if (!this.state.dontLoadSchedule)
            this.setState({ showSpinner: true });
        this.props.getScheduleInfo(m, this.onOpenScheculingCallCompleted, this.onEarliestScheduleCallCompleted);
    }

    savePatientInfo(patient) {
        console.log("savePatientInfo", patient);
        this.setState({ createPatient: patient });
    }

    createPatient(userInfo) {
        const patientModel = {
            email: userInfo.email,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            dateOfBirth: userInfo.dateOfBirth,
            gender: userInfo.gender,
            nationalIdentifier: userInfo.nationalIdentifier,
            departmentId: this.state.visit.department.id,
            departmentIdType: this.state.visit.department.idType
        };

        if (userInfo.patientPhone !== "") {
            patientModel.phoneNumbers = [{ number: userInfo.patientPhone, type: "Home Phone" }];
        }

        if (userInfo.mailingAddress && userInfo.mailingAddress.streetNumber !== "") {
            patientModel.houseNumber = userInfo.mailingAddress.streetNumber;
            patientModel.streetLine1 = userInfo.mailingAddress.streetNumber + " " + userInfo.mailingAddress.street;
            patientModel.city = userInfo.mailingAddress.city;
            patientModel.state = userInfo.mailingAddress.state;
            patientModel.zipCode = userInfo.mailingAddress.zip;
        }

        this.props.createPatient(patientModel, this.props.userToken);

        // insurance is added when creating a patient, but needed by ScheduleAppointment...
        if (userInfo.insuranceName !== "") {
            this.setState({
                insurance: {
                    insuranceName: userInfo.insurance.insuranceName,
                    memberNumber: userInfo.insurance.memberId,
                    groupNumber: userInfo.insurance.groupNumber,
                    subscriberId: userInfo.insurance.subscriberId
                }
            });
        }
    }

    getEndDate(dtStart) {
        let dtEnd = new Date(dtStart);
        dtEnd.setDate(1);
        let next = dtEnd.getDate() + 30;
        dtEnd.setDate(next);
        return dtEnd;
    }

    onBack(stepManager, currentStep) {
        this.setState({ scheduleErrorMessage: "" });

        //Load step at top of page
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }

    onStepChange = (success, step) => {
        //Bug 31808: Mobile scheduling: Load step at top of page
        //Load step at top of page
        if (typeof window !== 'undefined' && success) {
            window.scrollTo(0, 0);
        }

        if (success) {
            this.setState({ currentStep: step });
        }
    }

    tryAgain = (startingStep) => {
        this.setState({
            scheduleCompleted: false,
            startingStep: typeof startingStep !== 'undefined' ? startingStep : this.state.startingStep,
            isAddDependentSkipped: false
        }, () => this.refOurStepManager.current.wrappedInstance.refresh());
    }

    onUserSwitched = (userSelected, index) => {
        this.userSelected = userSelected;
        this.props.switchToMyChartUser(userSelected, index);
    }

    onSkipProxy = (isAddDependentSkipped) => {
        this.setState({ isAddDependentSkipped });
    }

    callbackOnLeave = () => {
        const { serverData } = this.props;
        const { scheduleType } = this.state;
        const stepManager = this.refOurStepManager.current.wrappedInstance;
        let restartAtStep = null;
        //const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling && scheduleType === "DirectSchedule";
        this.updateAddDependentShowPreference();
        if (window.userToSwitch) {
            this.props.switchToMyChartUser(window.userToSwitch, window.userToSwitch.index);
            this.userSelected = null;
            // if (!enableCustomDirectScheduling)
            //     restartAtStep = 0;
            if (stepManager && stepManager.childCollection && stepManager.childCollection[1] && stepManager.childCollection[1].props && stepManager.childCollection[1].props.steptitle.toLowerCase() === "select doctor"){
                restartAtStep = 1;
            }
            else {
                restartAtStep = 0;
            }
            if (restartAtStep)
                this.refOurStepManager.current.wrappedInstance.goBack(restartAtStep, true);
        }
    }

    getCurrentStepTitleName() {
        let stepTitle = '';
        const { currentStep } = this.state;
        if (this.refOurStepManager && this.refOurStepManager.current && this.refOurStepManager.current.wrappedInstance && this.refOurStepManager.current.wrappedInstance.childCollection) {
            const stepManager = this.refOurStepManager.current.wrappedInstance;
            stepTitle = stepManager.childCollection[currentStep] && stepManager.childCollection[currentStep].props && stepManager.childCollection[currentStep].props.steptitle ?
                stepManager.childCollection[currentStep].props.steptitle : '';
        }

        return stepTitle;
    }

    getIndexByStepTitle(title) {
        let index = -1;
        if (this.refOurStepManager && this.refOurStepManager.current && this.refOurStepManager.current.wrappedInstance && this.refOurStepManager.current.wrappedInstance.childCollection) {
            const stepManager = this.refOurStepManager.current.wrappedInstance.childCollection;
            for (let i = 0; i < stepManager.length; i++) {
                let stepTitle = stepManager[i].props.steptitle;
                if (stepTitle && title && stepTitle.toLowerCase() === title.toLowerCase()) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }

    updateAddDependentShowPreference = () => {
        const { savePreferenceCall } = this.props;
        const { isAddDependentSkipped } = this.state;
        if (isAddDependentSkipped && savePreferenceCall)
            savePreferenceCall();
    }

    getAppointmentType = (visitType) => {
        logUI(`MBHWeb.UI.Schedule.AppointmentType.Clicked`, new Date(), Tools.getURLPath(), visitType);
        const { visit } = this.state;
        const { visitTypeAndLocation } = this.props;

        if (visitType && visitType.value) {
            const idType = visitType.value.split('|');
            const selectedVisitId = idType && idType.length > 1 ? idType[0] : null;
            let found = false;
            if (selectedVisitId) {
                if (visit && visit.visitType) {
                    const directVisit = {};
                    if (visitTypeAndLocation && visitTypeAndLocation.visitTypes) {
                        const visitTypes = visitTypeAndLocation.visitTypes;
                        if (visitTypes) {
                            for (let i = 0; i < visitTypes.length; i++) {
                                const v = visitTypes[i];
                                for (let j = 0; j < v.iDs.length; j++) {
                                    const id = v.iDs[j];
                                    if (id.id === selectedVisitId) {
                                        directVisit.visitType = {
                                            id: id.id,
                                            idType: id.type,
                                            description: v.displayName
                                        };
                                        found = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if (found) {
                        //this.setState({ loadVisitType: `${directVisit.visitType.id}|${directVisit.visitType.idType}`, dontLoadSchedule: false });
                        const departmentId = visitTypeAndLocation && visitTypeAndLocation.departments && visitTypeAndLocation.departments[0] && visitTypeAndLocation.departments[0].iDs && visitTypeAndLocation.departments[0].iDs[0] && visitTypeAndLocation.departments[0].iDs[0].id ? visitTypeAndLocation.departments[0].iDs[0].id : this.state.visit.department.id;

                        this.saveStepInfo({
                            dontLoadSchedule: false, visit: {
                                ...this.state.visit,
                                department: {
                                    id: departmentId, address: { street1: "", street2: "", city: "", state: "", zip: "" }, phone: "", idType: ""
                                },
                                visitType: { description: directVisit.visitType.description, id: directVisit.visitType.id, idType: directVisit.visitType.idType }
                            }
                        }, true);
                    }

                }
            }
        }
    }

    selectedDayAvailabilty = (val) => {
        this.apptSlotNotAvailable = val;
    }

    selectedTimeAvailability = (val) => {
        this.apptTimeNotAvailable = val;
    }

    selectPatientMarkup = (hasProxyUsers, noSelectPatient, myProxies, hasMyChart, currentUser, isAdult, serverData, showDependentProxyForm) => {
        //const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling && this.state.scheduleType === "DirectSchedule";
        const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info");
        const { isFromDotCOM, visit, isFromVideoVisitOptions } = this.state;
        const goToApptInfo = isFromDotCOM && !isFromVideoVisitOptions && visit.visitType.id && visit.department.id ? true : false;
        const reasonSubmitStepValue = this.getIndexByStepTitle("Verify & Schedule");
        const enableNewProviderSchedulingWorkflow = this.props.serverData && this.props.serverData.enableNewProviderSchedulingWorkflow;

        if (hasProxyUsers && !noSelectPatient) {
            return (<SelectPatient
                steptitle="Select Patient"
                myProxies={myProxies}
                hasMychart={hasMyChart}
                currentUser={currentUser}
                switchToMyChartUser={this.onUserSwitched}
                isAdult={isAdult}
                userSelected={this.state.userSelected}
                onUserSelected={userSelected => this.userSelected = userSelected}
                shouldHideContinueButton
                activityCode="MBHWeb.UI.Schedule.AddDependent.Clicked"
                message={"I'm scheduling an appointment for..."}
                iconLeftClass={"svg-schedule-color"}
                serverData={serverData}
                location={this.props.location}
                goToApptInfo={goToApptInfo}
                apptInfoStepValue={apptInfoStepValue !== -1 ? apptInfoStepValue : 0}
                reasonSubmitStepValue={reasonSubmitStepValue !==-1 ? reasonSubmitStepValue: 0}
                enableNewProviderSchedulingWorkflow={enableNewProviderSchedulingWorkflow}
                apptSlotNotAvailable={this.apptSlotNotAvailable}
                apptTimeNotAvailable={this.apptTimeNotAvailable}
                isFromDotCOM={isFromDotCOM}
            />);
        }
        else if (!hasProxyUsers && !noSelectPatient && hasMyChart && (showDependentProxyForm) && isAdult) {
            return (<NoProxy
                steptitle="Select Patient"
                shouldHideContinueButton
                removeActive
                message={"I'm scheduling an appointment for..."}
                myProxies={myProxies}
                currentUser={currentUser}
                switchToMyChartUser={this.onUserSwitched}
                stepHeading={"Did you know?"}
                titleInfo={"You can schedule an appointment for a dependent."}
                iconLeftClass={"svg-schedule-color"}
                iconRightClass={"svg-dependent"}
                onSkipProxy={this.onSkipProxy}
                activityCode="MBHWeb.UI.Schedule.NoProxy.AddDependent.Clicked"
                goToApptInfo={goToApptInfo}
                apptInfoStepValue={apptInfoStepValue !== -1 ? apptInfoStepValue : 0} 
                reasonSubmitStepValue={reasonSubmitStepValue !== -1 ? reasonSubmitStepValue : 0}
                enableNewProviderSchedulingWorkflow={enableNewProviderSchedulingWorkflow}
                apptSlotNotAvailable={this.apptSlotNotAvailable}
                apptTimeNotAvailable={this.apptTimeNotAvailable}
                isFromDotCOM={isFromDotCOM}
                hasMychart={hasMyChart}
            />);
        }
    }

    setDepartmentID = (val) => {
        this.setState({
            newDepartArray: val
        })
    }

    render() {
        let visitTypes = [];
        let departments = [];
        let schedule = [];
        let provider = null;
        let selectedSlotAvailable = true;
        let visitReason = this.state.visit.reasonForVisitValue ? this.state.visit.reasonForVisitValue : "";
        const stepManager = this.refOurStepManager && this.refOurStepManager.current && this.refOurStepManager.current.wrappedInstance;

        if (this.props.visitTypeAndLocation) {
            visitTypes = this.props.visitTypeAndLocation.visitTypes ? this.props.visitTypeAndLocation.visitTypes.map((v, i) => { return { label: v.displayName, startDate: v.earliestCachedSlotDate, value: `${v.iDs[0].id}|${v.iDs[0].type}` }; }) : [];
            departments = this.props.visitTypeAndLocation.departments ? this.props.visitTypeAndLocation.departments.map((d, i) => { return { label: d.name, label2: d.displayName, value: `${d.iDs[0].id}|${d.iDs[0].type}`, address1: d.address1, address2: d.address2, city: d.city, state: d.state, zip: d.zip, phone: d.phone }; }) : [];
            schedule = this.props.providerSchedule;
            provider = this.props.visitTypeAndLocation.provider;

            // make sure the date/time passed in via route params is actually available...
            if (schedule && schedule.scheduleDays && this.state.visit.date !== "" && this.state.visit.time !== "") {
                const selDate = schedule.scheduleDays.filter(slot => slot.date === this.state.visit.date);
                if (selDate && selDate.length > 0) {
                    const selTime = selDate[0].slots.filter(time => time.time === this.state.visit.time);
                    if (!selTime) {
                        selectedSlotAvailable = false;
                    }
                }
                else {
                    selectedSlotAvailable = false;
                }
            }
        }

        let insurance = [];
        if (this.props.providerDetails && this.props.providerDetails.length > 0) {
            for (var i = 0; i < this.props.providerDetails[0].insuranceV2.length; i++) {
                const ins = this.props.providerDetails[0].insuranceV2[i];
                const found = insurance.some((item) => item.label === ins.companyName);
                if (!found) {
                    insurance.push({ label: ins.companyName, value: ins.companyName });
                }
            }
        }

        const { startingStep, visit, visitTypeChanged, locationChanged, startDate, scheduleErrorMessage, baseURL, createPatient, showSpinner, scheduleCompleted, currentStep, noSelectPatient, isFromVideoVisitOptions, scheduleType, isFromVideoVisitDirectSchedule, npi, epicId, isFromDotCOM } = this.state;
        const {
            searchRunning, visitTypeAndLocationFailed, currentUser, createPatientSuccess, createPatientFailed, hasMyChart, myProxies, serverData, getSchedulePending, getScheduleError, earliestScheduleWaiting, earliestScheduleError,
            match, visitTypeAndLocation, screenBreakPoint,primaryUser, scheduleAppointmentFailed, scheduleAppointmentSuccess, scheduleAppointmentPending, providerScheduleSuccessStatus, epicEHRDown, showDependentProxyForm, age, providerList, providerNpiListStr, providerNpiList, providerListPending, providerDetailsPending, getProviderDetail, visitTypeAndLocationPending, visitTypeAndLocationSuccess, proxyListFailure, proxyListLoaded
        } = this.props;

        const providerDetails = this.props.providerDetails && this.props.providerDetails.length > 0 ? this.props.providerDetails[0] : null;
        const hasMajorFailure = scheduleCompleted && scheduleErrorMessage;
        const hasProxyUsers = serverData && serverData.scheduleAppointmentForProxy && hasMyChart && myProxies && myProxies.length > 1;
        const needPatientInfo = typeof currentUser === "undefined" || currentUser === null || !hasMyChart;
        const isAdult = age && age > 17 ? true : false;
        const appointmentInfoWaiting = this.props.getSchedulePending || this.props.earliestScheduleWaiting || showSpinner;
        const enableDirectScheduling = window.serverData && window.serverData.data.enableDirectScheduling && scheduleType === "DirectSchedule";
        const safeCareMsg = serverData && serverData.safeCareMsg ? <StaticHtmlContent content={serverData.safeCareMsg} /> : '';
        const enableNewProviderSchedulingWorkflow =  serverData && serverData.enableNewProviderSchedulingWorkflow;
        const enableOpenScheduling = enableNewProviderSchedulingWorkflow && scheduleType === "OpenSchedule";
        //const showSelectDoctor = enableCustomDirectScheduling && !npi && !epicId;
        //const showNoProvidersAvailable = !proxyListFailure && proxyListLoaded && enableCustomDirectScheduling && !providerListPending && !providerDetailsPending && providerNpiList && providerNpiList.length === 0;
        const currentStepTitleName = this.getCurrentStepTitleName();
        const showPreviousBtn_PatientStatus = currentStepTitleName && ((currentStepTitleName.toLowerCase() === 'patient status') ||  (currentStepTitleName.toLowerCase() === 'reason for visit'))&& (currentStep === 1 || currentStep === 2);
        const showPreviousBtn = !isFromVideoVisitOptions && currentStepTitleName && currentStepTitleName.toLowerCase() === 'appointment info';
        const showPreviousBtn_VisitInfo = currentStepTitleName && (currentStepTitleName.toLowerCase() === 'select location') || (currentStepTitleName.toLowerCase() === 'visit type' && currentStep === 1 && provider && visitTypes) ;
        const locationCondition = enableNewProviderSchedulingWorkflow && this.state.newDepartArray && this.state.newDepartArray.length > 1 ?  true : false;
        const showLocationInfo = locationCondition ? true : ( !enableNewProviderSchedulingWorkflow && !isFromVideoVisitOptions && departments && departments.length > 1);
        const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false
        const showVerifyScheduleFlow =  enableNewProviderSchedulingWorkflow && !isFromVideoVisitOptions && !enableDirectScheduling;
        const apptInfoStepValue = this.getIndexByStepTitle("Appointment Info")
        return (!hasMyChart || !epicEHRDown)
            ? <div className="container-fluid body-content open-schedule-container full-width">
                <div className="row">
                    {visitTypeAndLocationFailed
                        ? <div className="col-12 maxWidth-content">
                            <AppointmentInfo searchRunning={searchRunning} waiting={appointmentInfoWaiting} isFromVideoVisitOptions={isFromVideoVisitOptions}
                                provider={provider} providerDetails={providerDetails} providerSearchModel={this.props.providerSearchModel} departments={departments} schedule={schedule}
                                visit={visit} visitTypes={visitTypes} visitTypeAndLocationFailed={visitTypeAndLocationFailed} visitTypeChanged={visitTypeChanged} locationChanged={locationChanged}
                                routeDate={match.params.date} routeTime={match.params.time} setScheduleDates={this.setScheduleDates} saveSlot={this.saveSlot} saveStepInfo={this.saveStepInfo}
                                resetWizard={this.resetWizard} startDate={startDate} providerScheduleSuccessStatus={providerScheduleSuccessStatus} getScheduleError={this.props.getScheduleError}
                                earliestScheduleError={this.props.earliestScheduleError} showErrors={searchRunning === false && showSpinner === false}
                                routeStepNumber={match.params.step ? match.params.step : 0} earliestSchedule={this.props.earliestSchedule} isDisableSelectVisitAndDepartOption={false} isDirectVisit={this.state.scheduleType === 'DirectSchedule'}
                            />
                        </div>
                        :
                        !scheduleCompleted
                            ? <div className="col-12">
                                <ScheduleBannerMsg />
                                <div className="row open-schedule__steps">
                                    <div className="col-12 progtrckr-divider" />
                                    <div className="col-12 maxWidth-content">
                                        <div className={"step-progress" + (showPreviousBtn ? ' showprev-btn' : showPreviousBtn_VisitInfo ? ' showprev_visitInfo ' : showPreviousBtn_PatientStatus ? ' showPreviousBtn_patientStatus ' : ' ')}>

                                            <OurStepManager ref={this.refOurStepManager} baseURL={baseURL} preventEnterSubmission startingStep={startingStep} onStepChange={this.onStepChange} majorFailure={hasMajorFailure} isFromDotCOM={isFromDotCOM} disableNextButton={false} nextButtonCls={"btn"}>
                                                {!this.fromPreventiveCareTile && this.selectPatientMarkup(hasProxyUsers, noSelectPatient, myProxies, hasMyChart, currentUser, isAdult, serverData, showDependentProxyForm)}
                                                {(enableNewProviderSchedulingWorkflow && !isFromVideoVisitOptions && !enableDirectScheduling ) && <PatientStatus steptitle="Patient Status"  loadVisitType={this.loadPatientStatus} patientType={this.state.visit && this.state.visit.patientStatus} isFromDotCOM={isFromDotCOM} routeDate={this.state.visit && this.state.visit.visitType && this.state.visit.visitType.startDate ? this.state.visit.visitType.startDate : match.params.date} routeTime={match.params.time} departments={departments} providerData={provider} visitTypeAndLocationInfo={visitTypeAndLocation} saveStepInfo={this.saveStepInfo} visit={visit} serverData={serverData} isMobile={isMobile} />}

                                                {(enableNewProviderSchedulingWorkflow && !isFromVideoVisitOptions && !enableDirectScheduling) && <VisitTypeReason steptitle="Reason for Visit" reason={this.state.visit && this.state.visit.reasonForVisitValue} reasonAcceptType={this.state.visit && this.state.visit.acceptType} departmentIdArray={this.setDepartmentID} visit={visit} isFromDotCOM={isFromDotCOM} visitTypes={visitTypes} departments={departments} serverData={serverData} saveStepInfo={this.saveStepInfo} visitTypeAndLocationInfo={visitTypeAndLocation} />}

                                                {/* {showSelectDoctor &&
                                                    <SelectDoctor
                                                        steptitle="Select Doctor"
                                                        shouldHideContinueButton
                                                        directProviderList={providerList}
                                                        directProviderNpiList={providerNpiList}
                                                        // directProviderListSuccess={directProviderListSuccess}
                                                        directProviderListPending={providerListPending}
                                                        providerDetailsPending={providerDetailsPending}
                                                        //getDirectScheduleProviderList={}
                                                        getProviderDetail={getProviderDetail}
                                                        providerDetails={this.props.providerDetails}
                                                        loadVisitType={this.loadVisitTypeAndLocation}
                                                        safeCareMsg={safeCareMsg}
                                                        schedulingProcedure={serverData.schedulingProcedure}
                                                        showNoProvidersAvailable={showNoProvidersAvailable}
                                                        currentUser={currentUser}
                                                        primaryUser={primaryUser}
                                                        serverData={serverData}
                                                    />
                                                } */}
                                                {/* {enableCustomDirectScheduling && !isFromVideoVisitOptions &&
                                                    <AppointmentType
                                                        steptitle="Appt Type"
                                                        shouldHideContinueButton
                                                        visitTypes={visitTypes}
                                                        visitTypeAndLocationPending={visitTypeAndLocationPending}
                                                        visitTypeAndLocationFailed={visitTypeAndLocationFailed}
                                                        visitTypeAndLocationSuccess={visitTypeAndLocationSuccess}
                                                        getAppointmentType={this.getAppointmentType}
                                                        safeCareMsg={safeCareMsg}
                                                        serverData={serverData}
                                                    />
                                                } */}
                                                {(!isFromVideoVisitOptions && ((!enableNewProviderSchedulingWorkflow) || (enableDirectScheduling))) &&
                                                    <VisitTypeInfo steptitle="Visit Type" shouldHideContinueButton={!(provider && visitTypes)} provider={provider} routeDate={this.state.visit && this.state.visit.visitType && this.state.visit.visitType.startDate ?  this.state.visit.visitType.startDate : match.params.date} routeTime={match.params.time} setScheduleDates={this.setScheduleDates}  providerDetails={providerDetails} visitTypes={visitTypes} departments={departments} saveStepInfo={this.saveStepInfo} visit={visit} serverData={serverData} />
                                                }
                                                { showLocationInfo  && 
                                                    <LocationInfo steptitle="Select Location" visit={visit} enableNewProviderSchedulingWorkflow={enableNewProviderSchedulingWorkflow} newDepartArray={this.state.newDepartArray} hasProxyUsers={hasProxyUsers} showLocationInfo={showLocationInfo} enableOpenScheduling={enableOpenScheduling} routeDate={this.state.visit && this.state.visit.visitType && this.state.visit.visitType.startDate ?  this.state.visit.visitType.startDate : match.params.date} routeTime={match.params.time} backButtonText="Previous" departments={departments} saveStepInfo={this.saveStepInfo} serverData={serverData} />
                                                }
                                                <AppointmentInfo steptitle={"Appointment Info"} isFromVideoVisitOptions={isFromVideoVisitOptions} searchRunning={searchRunning} waiting={appointmentInfoWaiting}
                                                    provider={provider} selectedDayUnavailable={this.selectedDayAvailabilty} selectedTimeUnavailable={this.selectedTimeAvailability} providerDetails={providerDetails} providerSearchModel={this.props.providerSearchModel} departments={departments} schedule={schedule}
                                                    visit={visit} visitTypes={visitTypes} visitTypeAndLocationFailed={visitTypeAndLocationFailed} visitTypeChanged={visitTypeChanged} locationChanged={locationChanged}
                                                    routeDate={match.params.date} routeTime={match.params.time} setScheduleDates={this.setScheduleDates} saveSlot={this.saveSlot} saveStepInfo={this.saveStepInfo}
                                                    resetWizard={this.resetWizard} startDate={startDate} providerScheduleSuccessStatus={providerScheduleSuccessStatus} getScheduleError={this.props.getScheduleError}
                                                    showErrors={searchRunning === false && showSpinner === false} routeStepNumber={match.params.step ? match.params.step : 0} isFromDotCOM={isFromDotCOM}
                                                    earliestSchedule={this.props.earliestSchedule} earliestScheduleError={this.props.earliestScheduleError} serverData={serverData} visitTypeSelectedValue={isFromVideoVisitDirectSchedule}
                                                    history={this.props.history} hasMyChart={hasMyChart}  enableNewProviderSchedulingWorkflow={enableNewProviderSchedulingWorkflow} isDisableSelectVisitAndDepartOption={!isFromVideoVisitOptions} isDirectVisit={this.state.scheduleType === 'DirectSchedule'}
                                                />
                        
                                                {needPatientInfo &&
                                                    <PatientInfo steptitle="Patient Info" model={createPatient} isMammogramSchedule={false} savePatientInfo={this.savePatientInfo} providerDetails={providerDetails} 
                                                        insurancePlans={insurance} createPatientSuccess={createPatientSuccess} createPatientFailed={createPatientFailed} userHasEmail={this.props.patientEmail}
                                                    />
                                                }
                                                {showVerifyScheduleFlow ?
                                                    <VerifyAndSchedule steptitle={'Verify & Schedule'} isMobile={isMobile} apptInfoStepValue={apptInfoStepValue} isNonMyChartUser={!hasMyChart} stepManager={stepManager} visit={visit} provider={provider} onSubmit={this.scheduleAppointment} departments={departments} saveStepInfo={this.saveStepInfo} providerDetails={providerDetails} style={this.props.style} goBack={this.props.goBack} continueButtonText="Schedule It!"/> : 
                                                    <ReasonForVisit steptitle={'Reason & Submit'}
                                                    visit={visit} provider={provider} departments={departments} selectedSlotAvailable={selectedSlotAvailable} saveStepInfo={this.saveStepInfo} visitTypes={visitTypes}
                                                    insurancePlans={insurance} providerDetails={providerDetails} createPatientFailed={createPatientFailed} createPatient={this.createPatient} onSubmit={this.scheduleAppointment}
                                                    currentUser={currentUser} hasMyChart={hasMyChart} nonMyChartPatientDetails={createPatient} primaryUser={primaryUser} userDetails={this.props.userDetails}
                                                    resetWizard={this.resetWizard} scheduleErrorMessage={scheduleErrorMessage} scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy} continueButtonText="Schedule It!" serverData={serverData}
                                                />}
                                                
                                            </OurStepManager>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <div className="col-12">
                                <OpenScheduleConfirmation visitTypeReason={visitReason ? visitReason : this.state.visit.visitType.description} scheduleAppointmentPending={scheduleAppointmentPending} scheduleAppointmentSuccess={scheduleAppointmentSuccess} providerSearchModel={this.props.providerSearchModel}
                                    scheduleAppointmentFailed={scheduleAppointmentFailed} createPatientSuccess={createPatientSuccess} hasMyChart={hasMyChart} nonMyChartPatientDetails={createPatient}
                                    currentUser={currentUser} createPatientFailed={createPatientFailed} visit={visit} provider={provider} saveStepInfo={this.saveStepInfo} providerDetails={providerDetails}
                                    resetWizard={this.resetWizard} primaryUser={primaryUser} scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy} tryAgain={this.tryAgain}
                                    serverData={serverData}
                                    scheduleCampaignReferrer={this.scheduleCampaignReferrer}
                                />
                               
                            </div>
                    }
                    {(scheduleCompleted && window.serverData.data.enableQualtricsSurveyOpenScheduling) && <div className="row"><div className="col-12"><div id="bsw_qtx" /></div></div>}
                </div>
                {!scheduleCompleted && currentStep > 0 &&
                    <ConfirmationModal when={!scheduleAppointmentSuccess || !scheduleAppointmentFailed} noReload blockNavigation={this.blockNavigation} callbackOnLeave={this.callbackOnLeave} switchToMyChartUser={this.onUserSwitched} />
                }
                {!visitTypeAndLocationFailed && !getScheduleError && !earliestScheduleError && (showSpinner || searchRunning === true || scheduleAppointmentPending === true) && 
                    <Spinner />
                }
                {/* {enableCustomDirectScheduling && !proxyListFailure && !proxyListLoaded && <Spinner />} */}
                {(currentStepTitleName && (currentStepTitleName.toLowerCase() === 'visit type' || (isFromDotCOM && currentStepTitleName.toLowerCase() === 'appointment info'))  && visitTypeAndLocationPending && !visitTypeAndLocationFailed) && <Spinner />}
            </div>
            : <FeatureDisabled />;
    }

}

const mapStateToProps = (state, ownProps) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    const primaryUserDomain = d ? d.hydrateProxyUser(state.domain.pu) : {};
    const primaryUserSSO = state.sso.primaryUser;
    let primaryUser = primaryUserDomain || primaryUserSSO;
    let cur = d ? d.hydrateProxyUser(state.domain.cu) : {};

    // if the patient had to be created, add the created patient info to currentUser (note this doesn't update currentUser in state)...
    if (state.openScheduling.createdPatient) {
        const created = state.openScheduling.createdPatient;
        cur = {
            displayName: created.name,
            externalId: created.ids && created.ids.length > 0 ? created.ids[0].id : ""
        };
    }

    return {
        visitTypeAndLocation: state.openScheduling.visitTypeAndLocation,
        visitTypeAndLocationFailed: state.openScheduling.visitTypeAndLocationFailed,
        visitTypeAndLocationPending: state.openScheduling.visitTypeAndLocationPending,
        visitTypeAndLocationSuccess: state.openScheduling.visitTypeAndLocationSuccess && !state.openScheduling.error,
        providerSchedule: state.openScheduling.providerSchedule,
        providerScheduleSuccessStatus: (!state.openScheduling.providerSchedule || (state.openScheduling.success && !state.openScheduling.error)) ? true : false,
        getScheduleError: state.openScheduling.getScheduleError,
        searchRunning: state.openScheduling.searchRunning,
        scheduleAppointmentSuccess: state.openScheduling.scheduleAppointmentSuccess,
        scheduleAppointmentFailed: state.openScheduling.scheduleAppointmentFailed,
        scheduleAppointmentPending: state.openScheduling.scheduleAppointmentPending,
        createPatientSuccess: state.openScheduling.createPatientSuccess,
        createPatientFailed: state.openScheduling.createPatientFailed,
        loginStatus: state.domain.ls,
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        proxyList: state.memberships.proxyList,
        primaryUser: primaryUser,
        currentUser: cur,
        serverData: state.session.serverData,
        epicEHRDown: state.common.epicEHRDown,
        hasMyChart: state.domain.hm,
        patientEmail: state.domain.e,
        patientLoginId: state.domain.un,
        userToken: state.domain.t,
        userDetails: state.sso.userDetails,
        providerSearchModel: state.providers.searchModel,
        getSchedulePending: state.openScheduling.getSchedulePending,
        createPatientIds: state.openScheduling.createPatientIds,
        providerDetails: state.providers.providerDetails,
        earliestSchedule: state.openScheduling.earliestSchedule,
        earliestScheduleWaiting: state.openScheduling.earliestScheduleWaiting,
        earliestScheduleError: state.openScheduling.earliestScheduleError,
        externalID: state.domain.cu ? state.domain.cu.ei : null,
        internalID: state.domain.cu ? state.domain.cu.ii : null,
        myChartID: state.domain.cu ? state.domain.cu.mi : null,
        patientEID: state.domain.eid,
        myProxies: pl,
        previousMonthAvailable: state.openScheduling.previousMonthAvailable,
        userIsSwitching: state.memberships.switchingProxyUser,
        age: state.domain.age,
        showDependentProxyForm: state.session.showDependentProxyForm,
        history: state.session.history,
        providerList: state.directScheduling.providerList,
        providerNpiListStr: state.directScheduling.providerNpiListStr,
        providerNpiList: state.directScheduling.providerNpiList,
        providerListPending: state.directScheduling.providerListPending,
        providerDetailsPending: state.providers.detailsPending,
        screenBreakPoint: state.common.screenBreakPoint,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVisitInfo: (searchModel, enableNewProviderSchedulingWorkflow, getVisitInfoCallBack ) => {
            dispatch({
                type: types.OPEN_SCHEDULE_VISIT_TYPE_LOCATION,
                searchModel: searchModel,
                enableNewProviderSchedulingWorkflow : enableNewProviderSchedulingWorkflow,
                callback: getVisitInfoCallBack,
               
            });
        },
        getScheduleInfo: (searchModel, callback, callbackOfEarliesSchedule) => {
            dispatch({ type: types.OPEN_SCHEDULE_PROVIDER, searchModel, callback, callbackOfEarliesSchedule });
        },
        getEarliestSchedule: (searchModel, callback) => {
            dispatch({ type: types.OPEN_SCHEDULE_EARLIEST, searchModel, callback });
        },
        createPatient: (model, token) => {
            dispatch({
                type: types.OPEN_SCHEDULE_CREATE_PATIENT,
                model: model,
                token: token
            });
        },
        scheduleAppointment: (model, token, scheduleCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_SCHEDULE,
                model: model,
                token: token,
                callBack: scheduleCallBack
            });
        },
        createAndSchedule: (patientModel, scheduleModel, token, scheduleCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_CREATE_AND_SCHEDULE,
                patient: patientModel,
                schedule: scheduleModel,
                token: token,
                callBack: scheduleCallBack
            });

        },
        clearReduxState: () => {
            dispatch({ type: types.OPEN_SCHEDULE_CLEAR_REDUX_STATE });
        },
        getProviderDetail: (searchModel) => {
            dispatch({ type: types.PROVIDER_DETAIL, searchModel: searchModel });
        },
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
        savePreferenceCall: () => {
            dispatch({
                type: types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE
            });
        },
        updateBypassProxyAndInfo: payload => dispatch({ type: types.UPDATE_BYPASS_PROXY_AND_INFO, payload })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Schedule));